export class FileHelpers {
  static async getFilesAsDataUrl(files: FileList | File[]): Promise<string[]> {
    const dataUrlThreads: Promise<string>[] = [];
    for (const file of files) {
      dataUrlThreads.push(
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            if (typeof fileReader.result === 'string') {
              resolve(fileReader.result);
            }

            reject(fileReader.result);
          };
          fileReader.readAsDataURL(file);
        }),
      );
    }

    return await Promise.all(dataUrlThreads);
  }

  static async downloadTextFile(text: string, fileName: string) {
    const file = new File([text], fileName);
    return await this.downloadFile(file, fileName);
  }

  static async downloadFile(file: File, fileName: string) {
    const dataUrl = (await this.getFilesAsDataUrl([file]))[0];
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
